import fetchServer from "../../fetchServer";

export default async function getTeamProfile(data) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching user profile!",
  };

  await fetchServer({ method: "GET", url: "/main/v1/adminTeam/profile?populate=roles" })
    .then((res) => {
      if (res.data && res?.data?.data) {
        result = { return: 1, msg: "Welcome", data: res.data?.data };
      } else result["msg"] = res?.data?.error || result["msg"];
    })
    .catch((err) => {
      console.log(err);
      result["msg"] = err.message;
      console.log("Network Error!");
    });

  return result;
}
